// Unified layout constants for all V3 tabs
export const V3_LAYOUT = {
    // Mobile: 64px (8*8), Desktop: 10px (1.25*8)
    HEADER_CLEARANCE: { xs: 8, sm: 8, md: 8 },
    // Bottom padding for mobile navigation
    BOTTOM_NAV_CLEARANCE: { xs: 8, sm: 8, md: 8 },
    // Content padding
    CONTENT_PADDING: { xs: 1, sm: 2, md: 3 }
};